// eslint-disable-next-line no-unused-vars
var validator={
    isValidRFCSatImpl:function(value){
        //validates the RFC
        return /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/.test(value)
    },
    isValidLengthRfc:function(value){
        return value.length==13||value.length==12;
    },   
};
export {validator}